import React from 'react';

// Components
import { MainNavigationPersonalNavItemList } from './MainNavigationPersonalNavItemList';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';
import { StateIndicator } from '../../../../_lib/components/StateIndicator';

import { getTitle } from '../../../../lib/NavigationItemsUtils';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { Breakpoints } from '../../../../types/Breakpoints';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { NavItem } from '../../../../types/api/NavItem';
import { FetchSubPanel } from '../../MainNavigationTypes';
import { NextPanelButton } from '../SubPanels/NextPanelButton';

type MainNavigationNavItemProps = {
  navItem: NavItem;
  fetchSubPanel?: FetchSubPanel;
  panelLevel?: number;
  activeOpenButtonId?: string;
  setActiveOpenButtonId?: (activeOpenButtonId: string | undefined) => void;
};
/**
 * An item in <a href='#mainnavigationgroup'>MainNavigationGroup</a>.
 * Uses <a href='#mainnavigationpersonalnavitemlist'>MainNavigationPersonalNavItemList</a>.
 */
export function MainNavigationNavItem({
  navItem,
  fetchSubPanel,
  panelLevel,
  activeOpenButtonId,
  setActiveOpenButtonId,
}: MainNavigationNavItemProps) {
  const { windowInnerWidth } = useAppContext();

  return (
    <li className="main-navigation__item">
      <div className="main-navigation__linkbox">
        <Hyperlink
          to={navItem.link.url}
          className="main-navigation__link font-medium-15-19"
          title={getTitle(navItem)}
          tooltipPlacement={
            windowInnerWidth > Breakpoints.s_smartphone_landscape ? TooltipPlacement.RIGHT : TooltipPlacement.BOTTOM
          }
        >
          {navItem.packState === 'onlyDraftVersion' && <StateIndicator status="red" modifier="main-navigation-item" />}
          {navItem.packState === 'template' && <StateIndicator status="purple" modifier="main-navigation-item" />}
          <span className="main-navigation__link-text">{navItem.link.name}</span>
        </Hyperlink>
        {navItem?.fetchUrl && fetchSubPanel && panelLevel
          ? (
              <NextPanelButton
                panelName={navItem?.link?.name}
                url={navItem?.link?.url}
                fetchUrl={navItem?.fetchUrl?.url}
                fetchSubPanel={fetchSubPanel}
                panelLevel={panelLevel}
                activeOpenButtonId={activeOpenButtonId}
                setActiveOpenButtonId={setActiveOpenButtonId}
              />
            )
          : null}
      </div>
      {navItem.personalNavItems
        ? (
            <MainNavigationPersonalNavItemList
              personalNavItems={navItem.personalNavItems}
              fetchSubPanel={fetchSubPanel}
              panelLevel={panelLevel}
              activeOpenButtonId={activeOpenButtonId}
              setActiveOpenButtonId={setActiveOpenButtonId}
            />
          )
        : null}
    </li>
  );
}
